import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationAwaitingCourier = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationAwaitingCourier',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 101 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70644)",
    fillRule: "evenodd",
    d: "M63.29 70.4H14.21c-2.21 0-4-1.79-4-4V17.29h53.08V70.4Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6A73E2",
    fillRule: "evenodd",
    d: "M63.29 17.29v20.78L10.21 27.68V17.29h53.08Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#EBD4FF",
    fillRule: "evenodd",
    d: "M53.7 31.99H.36l9.85-14.7h53.08l-9.59 14.7Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70644)",
    fillRule: "evenodd",
    d: "M85.49 70.4h-22.2V17.29h26.2V66.4c0 2.2-1.79 4-4 4Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#4951BF",
    fillRule: "evenodd",
    d: "M63.29 17.29v20.78l26.2-.59V17.29h-26.2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#2A44C6",
    fillRule: "evenodd",
    d: "M73.01 31.99h27.35l-9.62-14.7H63.29l9.72 14.7Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FFAF00",
    d: "M44.027 66.987c1.73-10.915-5.717-21.165-16.632-22.895C16.48 42.362 6.229 49.81 4.499 60.724 2.77 71.64 10.216 81.89 21.132 83.62c10.915 1.73 21.166-5.717 22.895-16.633Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.48 64.82V54.8h-5.34v11.01l.01.19c.04.57.27 1.12.64 1.55l5.65 6.54 4.04-3.49-5-5.78Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70644",
    x1: -3.528,
    x2: 78.156,
    y1: 19.744,
    y2: 66.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD1FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.817,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70644",
    x1: 47.416,
    x2: 110.692,
    y1: 59.725,
    y2: 23.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.227,
    stopColor: "#3740BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#EBD4FF"
  }))));
};
ColoredIllustrationAwaitingCourier.displayName = 'ColoredIllustrationAwaitingCourier';
export default withProvisionalOverrideFromContext(ColoredIllustrationAwaitingCourier);
//# sourceMappingURL=index.js.map